import { formatters } from 'folio-common-utils';
import * as React from 'react';
import { type RootState, useSelector } from '../../../state';
import * as foundingSelectors from '../../../state/founding/selectors';
import { getBankUrl } from '../../../utils';
import { StepContainer } from '../Container';
import { StepHeading } from '../step-heading';

function brregLink(orgId: string) {
  return `https://w2.brreg.no/enhet/sok/detalj.jsp?orgnr=${orgId}`;
}

function selector(state: RootState) {
  let companyName;
  let orgId;

  const details = state.founding.foundingDetails;

  if (details) {
    companyName = details.name || '';
    orgId = foundingSelectors.getOrgId(state) || '';
  }

  return {
    companyName,
    orgId,
    bankSelection: state.founding.bankSelection,
  };
}

export const DoneStep: React.FC = () => {
  const { companyName, orgId, bankSelection } = useSelector(selector);
  return (
    <StepContainer>
      <StepHeading>Ditt AS er registrert!</StepHeading>

      <p>
        {companyName} er oppført i Brønnøy&shy;sund&shy;registrene med{' '}
        <a href={brregLink(orgId)} target="_blank">
          organisasjons&shy;nummer {formatters.formatOrgNumber(orgId)}
        </a>
        .
      </p>

      {bankSelection === 'FOLIO_ONBOARDED' ? (
        <p>
          Aksjekapitalen står på{' '}
          <a href={getBankUrl(orgId)}>bedriftens bankkonto i Folio</a>. Du kan
          bruke av denne til å betale gebyret på 6500 til
          Brønnøy&shy;sund&shy;registrene.
        </p>
      ) : (
        <p>
          <b>Folio kan hjelpe deg med mer!</b>
          <br />
          Vi har laget et firmakort som bokfører utgifter automatisk! Du kan
          bruke det selv om du har en annen bank.{' '}
          <a href="https://folio.no">Les om Folio-kortet her</a>.
        </p>
      )}
    </StepContainer>
  );
};
